export type { DetailContentGateProps, DetailContentGateRedirectOptions } from './DetailContentGate';
export type {
  DetailErrorMessage,
  UseDetailErrorRedirectParams,
} from './hooks/useDetailErrorRedirect';

export { default as DetailContentGate } from './DetailContentGate';
export { default as useDetailErrorRedirect } from './hooks/useDetailErrorRedirect';
